import type { BackendResponse } from '#open-fetch'

export default {
  auth: {
    guestsPages: ['login', 'register*'],
    protectedLayouts: ['default'],
    redirectToAfterLogin: () => (user: BackendResponse<'getApiAuthMe'>) => {
      const route = useRoute()

      if (user.agency) {
        return route.query.redirect || '/'
      }

      return externalUrl('www', { name: 'account' })
    },
    redirectToIfUnauthenticated: 'login',
    shouldRemainAuthFns: () => ({
      login: (user: BackendResponse<'getApiAuthMe'>) => user.agency,
    }),
  },
}
